import * as ACTION from './constants';

const initialState = {
  accessDenied: false,
  authError: null,
  isAuthenticating: true,
  isAuthenticated: false,
  userData: null,
};

export default function reducers(state = initialState, action) {
  switch (action.type) {
    case ACTION.AUTH_BASE:
      return { ...initialState };
    case ACTION.AUTH_ERROR:
      return { ...initialState, authError: action.error };
    case ACTION.ACCESS_DENIED:
      return {
        ...state,
        accessDenied: true,
        isAuthenticating: false,
      };
    case ACTION.AUTHENTICATING:
      return {
        ...state,
        isAuthenticating: true,
        isAuthenticated: false,
        accessDenied: false,
        authError: null,
      };
    case ACTION.AUTH_SUCCESS:
      return {
        ...state,
        authError: null,
        accessDenied: false,
        isAuthenticating: false,
        isAuthenticated: true,
        userData: action.payload,
      };
    case ACTION.AUTH_COMPLETE:
      return {
        ...state,
        isAuthenticating: false,
      };
    case ACTION.SET_API_TOKEN:
      return {
        ...state,
        accessDenied: false,
        isAuthenticating: true,
        isAuthenticated: false,
        userData: {
          ...state.userData,
          token: action.token,
        }
      };
    case ACTION.SIGN_OUT:
      return {
        ...state,
        accessDenied: false,
        isAuthenticated: false,
        userData: null,
      };
    default:
      return state;
  }
}
